// extracted by mini-css-extract-plugin
export var background_img_curve = "index-module--background_img_curve--f+2AX";
export var background_img_curve_container = "index-module--background_img_curve_container--MaBxr";
export var brand_logo = "index-module--brand_logo--8ZXuc";
export var close_icon = "index-module--close_icon--iAgSg";
export var contact_info = "index-module--contact_info--VEKmG";
export var layover = "index-module--layover--Eqi52";
export var line_container = "index-module--line_container--wpn4f";
export var main_flex = "index-module--main_flex--os6SO";
export var main_nav = "index-module--main_nav--MCsjR";
export var nav_container = "index-module--nav_container--9dZo4";
export var nav_content_container = "index-module--nav_content_container--bshzg";
export var nav_links_container_main = "index-module--nav_links_container_main--10eQN";
export var nav_slider = "index-module--nav_slider--O2bz7";
export var request_call_form = "index-module--request_call_form--paos-";
export var show_layover = "index-module--show_layover--lOtkX";
export var show_nav = "index-module--show_nav--2elDD";
export var thick_line = "index-module--thick_line--Vj3Nj";
export var thin_line = "index-module--thin_line--4IRz7";
export var toggle_nav = "index-module--toggle_nav--xaiRu";
export var toggler = "index-module--toggler--ylsZv";
export var toggler_container = "index-module--toggler_container--qDoLp";
export var top_nav = "index-module--top_nav---eWj2";